import styled from 'styled-components';

export const Container = styled.div`
	&.AboutWrapper{
		max-width: 100%;
    /*padding: 0 10px;
    @media screen and (min-width: 768px) {
      padding: 0 25px;
    }*/
	}
	&.TopWrapper{
		margin: 0 10%;
	}
`;